"use client"

import { useForm } from "react-hook-form";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "./ui/form";
import { Input } from "./ui/input";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "./ui/button";
import { LoginFormSchema } from "@/schemas/login-form.schema";


interface Props {
    onSubmit: (data: z.infer<typeof LoginFormSchema>) => void
    isLoading: boolean,
}


export function LoginForm(props: Props) {

    const form = useForm<z.infer<typeof LoginFormSchema>>({
        resolver: zodResolver(LoginFormSchema),
        defaultValues: {
            email: "",
            password: "",
        },
    });

    function onSubmit(data: z.infer<typeof LoginFormSchema>) {
        props.onSubmit(data);
    }

    return (
        <Form {...form}>
            <form className="grid gap-y-4" onSubmit={form.handleSubmit(onSubmit)} autoComplete="off">
                <FormField control={form.control} name="email" render={({ field }) => (
                    <FormItem>
                        <FormLabel>Email</FormLabel>
                        <FormControl>
                            <Input disabled={props.isLoading} placeholder="Email" {...field} />
                        </FormControl>

                        <FormMessage />
                    </FormItem>
                )} />
                <FormField control={form.control} name="password" render={({ field }) => (
                    <FormItem>
                        <FormLabel>Password</FormLabel>
                        <FormControl>
                            <Input disabled={props.isLoading} type="password" placeholder="Password" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )} />
                <Button disabled={props.isLoading} className="w-full mt-4" type="submit">Submit</Button>
            </form>
        </Form>
    )
}